import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import classnames from 'classnames'

// Components
import {
  IconDollar,
  IconPencil,
  IconCheckCircle,
} from '../../../Icon'
import { Button, Text, Format, StatusIcon } from '../../../..'

// Styles
import styles from './ShowPaidExtraSuccess.module.scss'

const ShowPaidExtraSuccess = ({
  upbRequested,
  editPaidAmount,
  balanceDiff,
}) => (
  <div
    className={classnames(
      styles.extraPaymentSuccessContainer,
      upbRequested && styles.paidSoFarSpinning
    )}
  >
    <div className={styles.paidSoFarDollarIconWrapper}>
      <StatusIcon
        className={styles.paidSoFarDollarIcon}
        successIcon={IconDollar}
        success={!upbRequested}
        spin={upbRequested}
      />
    </div>
    <div className={styles.paidSuccessMessage}>
      <Text variant='neutralCool' variantCount='900' size='m'>
        <FormattedMessage
          id='Homeowner.interest.paidExtra.submitExtraSuccess'
          defaultMessage="You're paying down principal ahead of schedule — nice!"
        />
      </Text>
      <div className={styles.amountPaidExtraSection}>
        <Text className={styles.amountPaidExtra} variantCount='700' size='s'>
          <FormattedMessage
            id='Homeowner.interest.paidExtra.amountPaidSoFar'
            defaultMessage='{circleIcon} {amountPaidSoFar} extra paid so far'
            values={{
              amountPaidSoFar: (
                <Text variant='success' element='span'>
                  <Format.Currency value={balanceDiff} format='0,0' />
                </Text>
              ),
              circleIcon: (
                <IconCheckCircle variant='success' variantCount='700' />
              ),
            }}
          />
        </Text>
        <Button
          minimal
          iconStart={IconPencil}
          onClick={editPaidAmount}
          className={styles.buttonUpdateBalance}
        >
          <FormattedMessage
            id='Homeowner.interest.paidExtra.editButton'
            defaultMessage='Update your balance'
          />
        </Button>
      </div>
    </div>
  </div>
)

ShowPaidExtraSuccess.propTypes = {
  upbRequested: PropTypes.bool,
  editPaidAmount: PropTypes.func,
  balanceDiff: PropTypes.number,
}

export default ShowPaidExtraSuccess
